import { DataTable } from "components/elements/Datatable/data-table";
import { BaseRateTable } from "./components/base-rate-table";
import { BaseRateForm } from "./components/base-rate-form";

import { useContext } from "react";
import { LoanContext } from "providers/loan";
import { BaseRate } from "@common/loans/base-rate/base-rate.model";
import { useToast } from "@chakra-ui/react";

interface BaseRateTabProps {
  hideHeader?: boolean;
}

export function BaseRateTab({ hideHeader = true }: BaseRateTabProps) {
  const { loan } = useContext(LoanContext);
  const toast = useToast();

  const resource = {
    path: `loans/${loan!.id}/base-rates`,
    name: "Base Rate",
    title: "Base Rates",
  };

  const onAddNew = async () => {
    if (loan?.funding_date) {
      return true;
    }

    toast({
      title: "Funding date not set",
      description: "Please set the funding date",
      status: "error",
    });

    return false;
  };

  return (
    <DataTable<BaseRate>
      resource={resource}
      table={<BaseRateTable />}
      form={<BaseRateForm />}
      config={{
        hideHeader: hideHeader,
        hideSearch: true,
        hideMenu: true,
        onAddNew: onAddNew,
      }}
    />
  );
}
